import * as Yup from 'yup'

export const CreateTeamRoleSchema = Yup.object().shape({
  roleName: Yup.string().required('Role name is required'),
})
